import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useCallback, useState } from "react";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import _ from "lodash";
import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter, ModalCloseButton, useBreakpointValue, } from "@chakra-ui/react";
import SwipeDownDrawer from "../drawers/SwipeDownDrawer";
const ResponsiveModal = ({ isOpen, onOpen, onClose, paramKey = "drawer", children, header, showCloseButton = false, size = "md", bg = "#1E1E1E", color = "white", footer, mode, height, topText, removeParamOnRefresh = false, }) => {
    console.log("paramKey", paramKey);
    const isMobile = useBreakpointValue({ base: true, md: false });
    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();
    const [isModalOpen, setIsModalOpen] = useState(isOpen);
    const [updateParamInProgress, setUpdateParamInProgress] = useState(isOpen);
    const debouncedClose = useCallback(_.debounce(() => {
        handleClose();
    }, 100), []);
    const debouncedOpen = useCallback(_.debounce(() => {
        handleOpen();
    }, 100), []);
    useEffect(() => {
        const currentParams = new URLSearchParams(location.search);
        const hasModal = currentParams.has(paramKey);
        if (hasModal && !isModalOpen) {
            if (removeParamOnRefresh) {
                const newParams = new URLSearchParams(location.search);
                newParams.delete(paramKey);
                const newSearch = newParams.toString();
                navigate(`${location.pathname}${newSearch ? `?${newSearch}` : ""}`, {
                    replace: true,
                    state: { ...location.state },
                });
            }
            else {
                debouncedClose();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        if (isOpen) {
            setUpdateParamInProgress(true);
            debouncedOpen();
            setTimeout(() => {
                setUpdateParamInProgress(false);
            }, 200);
        }
        else if (isModalOpen) {
            navigate(-1);
            setIsModalOpen(false);
        }
    }, [isOpen]);
    useEffect(() => {
        if (updateParamInProgress)
            return;
        const currentParams = new URLSearchParams(location.search);
        const hasModal = currentParams.has(paramKey);
        if (!hasModal && isModalOpen) {
            setIsModalOpen(false);
            onClose();
        }
    }, [location.search, updateParamInProgress]);
    const handleOpen = () => {
        setIsModalOpen(true);
        const currentParams = new URLSearchParams(location.search);
        if (currentParams.has(paramKey)) {
            return;
        }
        const newSearchParams = new URLSearchParams(searchParams);
        newSearchParams.set(paramKey, "open");
        navigate(`${location.pathname}?${newSearchParams.toString()}`, {
            state: { ...location.state },
        });
    };
    const handleClose = () => {
        navigate(-1);
        setIsModalOpen(false);
        onClose();
    };
    if (isMobile) {
        return (_jsx(SwipeDownDrawer, { isOpen: isModalOpen, onOpen: onOpen || (() => { }), onClose: handleClose, content: children, header: header, footer: footer, showCloseButton: showCloseButton, bg: bg, color: color, mode: mode, defaultHeight: height, topText: topText }));
    }
    return (_jsxs(Modal, { isOpen: isModalOpen, onClose: handleClose, size: size, isCentered: true, children: [_jsx(ModalOverlay, {}), _jsxs(ModalContent, { bg: bg, color: color, borderRadius: "16px", pt: 4, transition: "transform 0.1s ease, height 0.3s ease-in-out", children: [_jsx(ModalCloseButton, {}), header && _jsx(ModalHeader, { children: header }), _jsx(ModalBody, { children: children }), footer && _jsx(ModalFooter, { children: footer })] })] }));
};
export default ResponsiveModal;
